module.exports = __webpack_public_path__ + "img/5.41d12230.png";